


















import Vue from "vue";

export default Vue.extend({
  name: "VoteField",
  props: {
    value: {
      type: Boolean,
      required: false,
    },
  },
});
